export default __webpack_public_path__ + "static/media/Team1.7d05aa5c.jpg";